import { Component, DestroyRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { API, MediumGroupCategoryDTO } from '../../../../services/api/api';
import { ModalNavigationComponent } from '../../../../services/gui/modal/modal-navigation-component';
import { ModalNavigationService } from '../../../../services/gui/modal/modal-navigation.service';
import { MsOptions } from '../../../../services/global/global-interfaces';
import { UtilService } from '../../../../services/util.service';
import { ErrorService } from '../../../../services/error.service';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-page-mediumGroup-category-edit',
  templateUrl: './medium-group-category-edit.component.html',
  styleUrls: ['./medium-group-category-edit.component.scss'],
  standalone: false,
})
export class MediumGroupCategoryEditComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;

  msCategoryOptions: MsOptions;
  @Input() mediumGroupCategory: MediumGroupCategoryDTO;
  @Output() saveClick: EventEmitter<boolean>;
  @Output() deleteClick: EventEmitter<boolean>;
  mediumGroupCategories: MediumGroupCategoryDTO[];

  constructor(
    public api: API,
    public modalNavigationService: ModalNavigationService,
    public util: UtilService,
    public errorHandler: ErrorService,
    private destroyRef: DestroyRef
  ) {
    this.mediumGroupCategories = [];
    this.saveClick = new EventEmitter();
    this.deleteClick = new EventEmitter();
  }

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.mediumGroupCategory = this.modalNavigationService.getCurrentNavigation().data.mediumGroupCategory;
    }
  }

  msRequest(type: string, options?: MsOptions) {
    if (type === 'MEDIUMGROUP_CATEGORIES') {
      if (options) {
        this.msCategoryOptions = options;
      }
      if (this.msCategoryOptions?.pagination) {
        this.api
          .mm_MediumGroupCategory_retrieveAll(
            {
              search: this.util.encodeSearchQueryParam(false, this.msCategoryOptions?.search),
              notInHierarchyOf: this.mediumGroupCategory?.id ?? null,
            },
            this.msCategoryOptions?.pagination
          )
          .pipe(take(1), takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: (categories: MediumGroupCategoryDTO[]) => {
              this.mediumGroupCategories = categories;
            },
            error: error => {
              this.errorHandler.errorHandler(error);
            },
          });
      }
    }
  }

  update($event: any[], type: string) {
    if (type === 'MEDIUMGROUP_CATEGORIES') {
      if ($event && $event.length > 0) {
        this.mediumGroupCategory.parent = $event[0];
      } else {
        this.mediumGroupCategory.parent = null;
      }
    }
  }
}
